import AmdrDetailsModal from "./AmdrDetailsModal";

export default AmdrDetailsModal;
